import {pluralizeModelNoun} from './modelNouns'
export const staffRoleTiers={admin:1,programcoach:2,headcoach:3,assistantcoach:4,selector:5,support:6} as const
export type StaffRole=keyof typeof staffRoleTiers
export type StaffNounEvent=Partial<Record<`staffTier${1|2|3|4|5|6}Noun`,string>>
export const capitalizeNoun=(value:string)=>value.charAt(0).toLocaleUpperCase()+value.slice(1)
export function staffRoleNoun(event:StaffNounEvent|undefined,role:StaffRole,fallback:string,plural=false){
 const value=event?.[`staffTier${staffRoleTiers[role]}Noun` as keyof StaffNounEvent]?.trim() || fallback
 return plural ? pluralizeModelNoun(value) : value
}
export function staffNounTerms(event:StaffNounEvent|undefined,fallback:string){
 const singular=staffRoleNoun(event,'selector',fallback),plural=pluralizeModelNoun(singular)
 return {staffSingular:singular,staffPlural:plural,staffTitle:capitalizeNoun(singular),staffPluralTitle:capitalizeNoun(plural)}
}
